import { render } from "./ProductDetail.vue?vue&type=template&id=11ce2815&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&id=11ce2815&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ce2815"]])

export default __exports__